module.exports = __webpack_public_path__ + "img/search-icon.70739b33.svg";